module.exports = __webpack_public_path__ + "static/media/routes06.31493e4f.webp";